<script setup>

import moment from 'moment'
import { useRouter, useRoute } from 'vue-router'
import JwtService from '@/common/jwt.service'
import jwtDecode from 'jwt-decode'
import { useStore } from 'vuex'
import { onMounted, ref } from 'vue'

import { MySelf } from '@/common/api.service'
import { initializeAuth, navigateAfterAuth } from '@/common/auth.service'

const router = useRouter()
const route = useRoute()
const store = useStore()
const authReady = ref(false)

onMounted(async () => {
  await router.isReady()

  const result = await initializeAuth(store, route)
  if (result.status === 'redirect') {
    return
  }

  if (result.status === 'oauth') {
    const { data } = await MySelf.card()
    await navigateAfterAuth(router, data)
  } else if (result.status === 'authenticated' && route.name === 'Auth') {
    await navigateAfterAuth(router)
  }

  authReady.value = true

  if (typeof store.getters.currentUser !== 'undefined') {
    if (typeof store.getters.currentUser.GROUP_ID !== 'undefined' && store.getters.currentUser.GROUP_ID.length > 1) {
      this.roleChangeAvail = true
    }
    if (!route.query.access_token) {
      let exp = jwtDecode(JwtService.getToken())
      let expDate = new Date()
      expDate.setTime(exp.exp * 1000)
      let date = new Date()
      if (expDate.getTime() < moment(date)
          .toDate()
          .getTime()) {
        //alert("Будет осуществлен выход из системы по причине не активности!");
        //this.logout()
      }
    }
  }
})
</script>
<template>
  <RouterView v-if="authReady" v-slot="{ Component, route }">
    <Suspense>
      <component :is="Component" :key="route.path"/>
    </Suspense>
  </RouterView>
</template>


